import client from "@/utils/api/client";
import { MaterialResponse } from "@/web-client/api";
import useSWR from "swr";

const useMaterials = (): MaterialResponse[] => {
  const { data } = useSWR<MaterialResponse[]>("/materials", async () => {
    const { data } = await client.materialsGet();

    return data;
  });

  return data || [];
};

export default useMaterials;
